import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/content';
export function Audience() {
  return <section className="border-y border-ink/10 bg-sand/60" data-id="element-14" data-mp="3p26wcbtajhqo">
      <div className="mx-auto grid max-w-5xl gap-12 px-6 py-16 md:grid-cols-2 md:gap-16 lg:py-24" data-id="element-15" data-mp="6uzls4ps1ynv">
        <div data-id="element-16" data-mp="1vd7dry7qcdh">
          <h2 className="font-display text-2xl font-semibold tracking-tight text-ink sm:text-3xl" data-id="element-17" data-mp="1uv6uj4ipbzr">
            Esto es para ti si...
          </h2>
          <ul className="mt-7 space-y-4" data-id="element-18" data-mp="btu5d8vkjr91">
            {forYou.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-ink/80" data-id="element-19" data-mp="brq1gqxo6s8r">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-20" data-mp="pkfsj9s22ncq" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="md:border-l md:border-ink/10 md:pl-16" data-id="element-21" data-mp="ukbwj90r6esa">
          <h2 className="font-display text-2xl font-semibold tracking-tight text-ink/60 sm:text-3xl" data-id="element-22" data-mp="um53kpfa310t">
            Esto no es para ti si...
          </h2>
          <ul className="mt-7 space-y-4" data-id="element-23" data-mp="1bbjdfm5wunsc">
            {notForYou.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-ink/55" data-id="element-24" data-mp="1gbe4pqtllfdx">
                <MinusIcon className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-25" data-mp="1kcrc45cc9qmy" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}